import { TransactionTypeEnum } from '@/services/types/TransactionData';

const transactionTypeLabels: Record<string, string> = {
  [TransactionTypeEnum.Transfer]: 'Bank transfer',
  [TransactionTypeEnum.Bank]: 'Payment',
  [TransactionTypeEnum.Purchase]: 'Purchases',
  [TransactionTypeEnum.Investment]: 'Investments',
  [TransactionTypeEnum.TopUp]: 'Top up',
  [TransactionTypeEnum.EmergePay]: 'Emerge Pay',
  [TransactionTypeEnum.Admin]: 'Admin',
  [TransactionTypeEnum.Tax]: 'Tax',
  [TransactionTypeEnum.Interest]: 'Interest',
  [TransactionTypeEnum.Return]: 'Returns'
};

export const getTransactionTypeLabel = (transactionType: string): string => {
  return transactionTypeLabels[transactionType] || transactionType;
};
